module.exports = __webpack_public_path__ + "static/media/achtung.e8127e24.svg";